import { deviceProvisionConstants } from '../Constants';
import { adminUsersServices } from '../Services';
import {editdeviceProvisionConstants} from "../Constants"

export const deviceProvisionsActions = {
    searchDeviceProvision,
    EditDeviceProvision
};

function searchDeviceProvision(data: any) {
    return (dispatch:any) => {
        dispatch(dispatchFunction({
            type: deviceProvisionConstants.SEARCH_DEVICEPROVISION_REQUEST,
            data: null
        }));
        adminUsersServices.deviceProvision(data)
            .then(
                response => {
                    if (response.status) {
                        dispatch(dispatchFunction({
                            type: deviceProvisionConstants.SEARCH_DEVICEPROVISION_SUCCESS,
                            data: response.data
                        }));
                    } else {
                        dispatch(dispatchFunction({
                            type: deviceProvisionConstants.SEARCH_DEVICEPROVISION_FAILURE,
                            data: response
                        }));
                    }
                },
                error => {
                    dispatch(dispatchFunction({
                        type: deviceProvisionConstants.SEARCH_DEVICEPROVISION_FAILURE,
                        data: error.message
                    }));
                }
            );
    };
}

function EditDeviceProvision(data:any) {
    return (dispatch:any) => {
        dispatch(dispatchFunction({
            type: editdeviceProvisionConstants.EDIT_DEVICEPROVISION_REQUEST,
            data: null
        }));
        adminUsersServices.EditDeviceProvision(data)
            .then(
                response => {
                    if (response.status) {
                        dispatch(dispatchFunction({
                            type: editdeviceProvisionConstants.EDIT_DEVICEPROVISION_SUCCESS,
                            data: response.data
                        }));
                    } else {
                        dispatch(dispatchFunction({
                            type: editdeviceProvisionConstants.EDIT_DEVICEPROVISION_FAILURE,
                            data: response
                        }));
                    }
                },
                error => {
                    dispatch(dispatchFunction({
                        type: editdeviceProvisionConstants.EDIT_DEVICEPROVISION_FAILURE,
                        data: error.message
                    }));
                }
            );
    };
}


function dispatchFunction(data: any) {
    // To do: check for refresh / unauthorized error
    return {
        type: data.type,
        data: data.data
    };
}